import { render, staticRenderFns } from "./ResidentCard.vue?vue&type=template&id=51437a18&scoped=true"
import script from "./ResidentCard.vue?vue&type=script&lang=js"
export * from "./ResidentCard.vue?vue&type=script&lang=js"
import style0 from "./ResidentCard.vue?vue&type=style&index=0&id=51437a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51437a18",
  null
  
)

export default component.exports